import React from 'react'
import { ArrowRight, Award, Clock, Users, CheckCircle, Star, Shield, Phone } from 'lucide-react'

const ServicesSection = () => {
  // Primary Hair Transplant Techniques
  const hairTransplantTechniques = [
    {
      name: "SAPHORÏ®",
      price: "à partir de 6800€",
      duration: "6-8h",
      recovery: "7-10 jours",
      description: "Technique la plus avancée avec extraction et implantation simultanées pour des résultats optimaux.",
      benefits: [
        "Résultats les plus naturels",
        "Densité maximale obtenue",
        "Cicatrisation optimisée",
        "Repousse garantie à 98%"
      ],
      premium: true
    },
    {
      name: "CHOÏ",
      price: "à partir de 5800€",
      duration: "5-7h",
      recovery: "5-7 jours",
      description: "Implantation directe avec stylet implanteur pour une précision maximale et angle naturel.",
      benefits: [
        "Précision millimétrique",
        "Angle naturel parfait",
        "Moins de traumatisme",
        "Récupération accélérée"
      ]
    },
    {
      name: "SAPHIR",
      price: "à partir de 3800€",
      duration: "4-6h",
      recovery: "3-5 jours",
      description: "Lames en saphir pour des incisions plus fines et une cicatrisation optimale.",
      benefits: [
        "Incisions ultra-fines",
        "Cicatrisation rapide",
        "Moins d'œdème",
        "Excellent rapport qualité/prix"
      ]
    }
  ]

  // Supporting Hair Services
  const hairSupportServices = [
    {
      name: "PRP Capillaire",
      price: "à partir de 300€",
      description: "Plasma riche en plaquettes pour stimuler la repousse naturelle"
    },
    {
      name: "Mésothérapie",
      price: "à partir de 95€",
      description: "Injections de vitamines et nutriments pour fortifier le cuir chevelu"
    },
    {
      name: "Tricopigmentation",
      price: "à partir de 800€",
      description: "Pigmentation du cuir chevelu pour effet densité immédiat"
    }
  ]

  // Secondary Services - Détatouage positioned first as trendy service
  const secondaryServices = [
    {
      name: "Détatouage Laser",
      price: "à partir de 80€",
      description: "PicoWay® Nouvelle Génération - Toutes couleurs d'encre, tous types de peau, résultats optimaux avec la technologie la plus avancée",
      icon: "",
      premium: true,
      trending: true,
      technology: "PicoWay® Nouvelle Génération",
      benefits: ["Toutes couleurs d'encre", "Sécurité maximale", "Résultats rapides", "Moins de séances"]
    },
    {
      name: "Épilation Laser",
      price: "à partir de 35€",
      description: "Épilation définitive laser, tous types de peau et de poils",
      icon: ""
    },
    {
      name: "Chirurgie Esthétique",
      price: "à partir de 1300€",
      description: "Rhinoplastie, lifting, augmentation mammaire, liposuccion",
      icon: ""
    },
    {
      name: "Médecine Esthétique",
      price: "à partir de 200€",
      description: "Botox, acide hyaluronique, Russian lips, soins anti-âge",
      icon: ""
    },
    {
      name: "Soins Visage & Corps",
      price: "à partir de 70€",
      description: "Microneedling, peeling, Hydrafacial®, soins personnalisés",
      icon: ""
    }
  ]

  const DOCTOLIB_URL = 'https://www.doctolib.fr/centre-laser-et-esthetique/paris/clinique-du-grand-paris'

  const openDoctolib = () => {
    window.open(DOCTOLIB_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <section id="services" className="section services">
      <div className="container">
        <h2 className="section-title reveal-hidden">Nos Services</h2>
        <p style={{ textAlign: 'center', color: 'var(--text-secondary)', marginBottom: '60px', fontSize: '1.1rem' }}>
          Spécialistes de la greffe capillaire à Paris avec 3 techniques exclusives et services complémentaires
        </p>

        {/* PRIMARY SECTION: Médecine Capillaire */}
        <div style={{ marginBottom: '80px' }}>
          {/* Ben Services Card - Matching Hero Section Style */}
          <div className="services-ben-card reveal-hidden reveal-stagger-1">
            {/* Ben's seated background image */}
            <div className="services-ben-bg">
              <img src="/assets/team/ben-no-bg-seated.png" alt="Ben - Expert Capillaire CDGP" />
            </div>

            {/* Content overlay */}
            <div className="services-overlay">
              <div className="services-text">
                {/* Trust badges */}
                <div className="services-stats">
                  <div className="stat-badge">
                    <Award size={20} />
                    <span>2000+ Greffes Réussies</span>
                  </div>
                  <div className="stat-badge">
                    <Star size={20} />
                    <span>98% Taux de Repousse</span>
                  </div>
                  <div className="stat-badge">
                    <Shield size={20} />
                    <span>3 Techniques Exclusives</span>
                  </div>
                </div>

                <h3 className="services-title">
                  Médecine Capillaire
                </h3>

                <p className="services-description">
                  Retrouvez vos cheveux avec nos 3 techniques de greffe capillaire exclusives : <strong>SAPHORÏ®</strong>, <strong>CHOÏ</strong> et <strong>SAPHIR</strong>
                </p>

                <button
                  className="services-cta"
                  onClick={openDoctolib}
                >
                  <CheckCircle size={18} />
                  DIAGNOSTIC GRATUIT
                </button>
              </div>
            </div>
          </div>

          {/* Hair Transplant Techniques Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '30px',
            marginBottom: '40px'
          }} className="services-grid reveal-hidden reveal-stagger-2">
            {hairTransplantTechniques.map((technique, index) => (
              <div key={index} style={{
                background: 'white',
                borderRadius: '16px',
                padding: '40px 30px',
                boxShadow: technique.premium
                  ? '0 8px 32px rgba(184, 155, 114, 0.2), 0 0 0 2px rgba(184, 155, 114, 0.3)'
                  : '0 4px 20px rgba(47, 47, 132, 0.08)',
                border: technique.premium ? '2px solid #8B6F47' : '2px solid #E8EAF6',
                position: 'relative',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)'
                  e.currentTarget.style.boxShadow = technique.premium
                    ? '0 12px 40px rgba(184, 155, 114, 0.3), 0 0 0 2px rgba(184, 155, 114, 0.4)'
                    : '0 8px 32px rgba(47, 47, 132, 0.15)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = technique.premium
                    ? '0 8px 32px rgba(184, 155, 114, 0.2), 0 0 0 2px rgba(184, 155, 114, 0.3)'
                    : '0 4px 20px rgba(47, 47, 132, 0.08)'
                }}>
                {technique.premium && (
                  <div style={{
                    position: 'absolute',
                    top: '-1px',
                    left: '20px',
                    right: '20px',
                    height: '4px',
                    background: 'linear-gradient(90deg, #8B6F47 0%, #2F2F84 50%, #8B6F47 100%)',
                    borderRadius: '2px 2px 0 0'
                  }}></div>
                )}

                <div style={{ textAlign: 'center', marginBottom: '25px' }}>
                  <h4 style={{
                    color: '#2F2F84',
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    marginBottom: '10px'
                  }}>
                    {technique.name}
                  </h4>
                  <div style={{
                    fontSize: '1.4rem',
                    fontWeight: '700',
                    color: technique.premium ? '#8B6F47' : '#2F2F84',
                    marginBottom: '15px'
                  }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}><span style={{ color: "#555", fontSize: "1rem" }}>à partir de</span><span style={{ color: "inherit" }}>{technique.price.replace("à partir de ", "")}</span></div>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
                    <span><Clock size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />{technique.duration}</span>
                    <span><Users size={14} style={{ verticalAlign: 'middle', marginRight: '4px' }} />{technique.recovery}</span>
                  </div>
                </div>

                <p style={{
                  color: 'var(--text-secondary)',
                  lineHeight: '1.6',
                  marginBottom: '25px',
                  textAlign: 'center'
                }}>
                  {technique.description}
                </p>

                <div style={{ marginBottom: '30px' }}>
                  {technique.benefits.map((benefit, i) => (
                    <div key={i} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      marginBottom: '8px',
                      fontSize: '0.95rem'
                    }}>
                      <CheckCircle size={16} color="#28a745" />
                      <span style={{ color: 'var(--text-secondary)' }}>{benefit}</span>
                    </div>
                  ))}
                </div>

                <button
                  className="btn"
                  onClick={openDoctolib}
                  style={{
                    width: '100%',
                    backgroundColor: technique.premium ? '#8B6F47' : '#2F2F84',
                    borderColor: technique.premium ? '#8B6F47' : '#2F2F84'
                  }}
                >
                  Diagnostic Gratuit
                  <ArrowRight size={16} />
                </button>
              </div>
            ))}
          </div>



          {/* Conversion CTA with Ben Introduction */}
          <div style={{
            marginTop: '60px',
            marginBottom: '60px'
          }}>
            {/* Strong Punchline Banner */}
            <div style={{
              textAlign: 'center',
              padding: '48px 40px',
              background: 'linear-gradient(135deg, #FFFFFF 0%, #E8EAF6 100%)',
              borderRadius: '16px',
              border: '2px solid #E8EAF6',
              boxShadow: '0 4px 16px rgba(47, 47, 132, 0.12)',
              position: 'relative',
              overflow: 'hidden',
              marginBottom: '40px'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: 'linear-gradient(90deg, #2F2F84 0%, #6466B0 50%, #8B6F47 100%)'
              }}></div>
              <h3 style={{
                color: '#2F2F84',
                marginBottom: '20px',
                fontSize: '1.8rem',
                fontWeight: '700'
              }}>
                Prêt à transformer votre vie ?
              </h3>
              <p style={{
                color: 'var(--text-secondary)',
                marginBottom: '32px',
                fontSize: '1.2rem',
                lineHeight: '1.6',
                maxWidth: '600px',
                margin: '0 auto 32px auto'
              }}>
                Diagnostic capillaire gratuit avec nos experts pour déterminer la meilleure technique pour vous
              </p>
              <button className="btn btn-gold" onClick={openDoctolib}>
                Réserver Mon Diagnostic Gratuit
                <ArrowRight size={20} />
              </button>
            </div>

            {/* Ben Assistant Introduction */}
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '40px',
              alignItems: 'center',
              background: 'linear-gradient(135deg, #FFFFFF 0%, #F8F9FF 100%)',
              borderRadius: '24px',
              padding: '48px',
              boxShadow: '0 12px 40px rgba(47, 47, 132, 0.1)',
              border: '2px solid #E8EAF6',
              position: 'relative',
              overflow: 'hidden'
            }} className="ben-introduction-section">
              {/* Decorative gradient bar */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '4px',
                background: 'linear-gradient(90deg, #2F2F84 0%, #6466B0 50%, #8B6F47 100%)'
              }}></div>

              {/* Ben's Video Container - Left side */}
              <div
                onClick={() => {
                  if (window.openBenChat) {
                    window.openBenChat('ben-video-click')
                  }
                }}
                style={{
                  flexShrink: 0,
                  cursor: 'pointer',
                  position: 'relative'
                }}
                className="ben-video-container"
              >
                <div style={{
                  width: '180px',
                  height: '180px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: 'linear-gradient(135deg, #2F2F84 0%, #6466B0 100%)',
                  padding: '4px',
                  boxShadow: '0 8px 32px rgba(47, 47, 132, 0.25)',
                  position: 'relative',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}>
                  <video
                    src="/mobile-optimized/videos/ben-loop-mobile.mp4"
                    autoPlay={true}
                    loop={true}
                    muted={true}
                    playsInline={true}
                    webkit-playsinline="true"
                    poster="/team/ben.jpg"
                    preload="metadata"
                    onLoadedData={(e) => {
                      const playPromise = e.target.play();
                      if (playPromise !== undefined) {
                        playPromise.catch(() => {
                          console.log('Autoplay prevented');
                        });
                      }
                    }}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      borderRadius: '50%'
                    }}
                    alt="Ben - Assistant Personnel CDGP"
                  />
                </div>

                {/* Online Status Badge */}
                <div style={{
                  position: 'absolute',
                  bottom: '8px',
                  right: '8px',
                  background: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)',
                  borderRadius: '20px',
                  padding: '6px 12px',
                  color: 'white',
                  fontSize: '0.75rem',
                  fontWeight: '700',
                  boxShadow: '0 4px 12px rgba(40, 167, 69, 0.4)',
                  border: '3px solid white',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}>
                  <div style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    background: '#fff',
                    animation: 'pulse 1.5s infinite'
                  }}></div>
                  En ligne
                </div>
              </div>

              {/* Content - Right side */}
              <div style={{ flex: 1 }}>
                <h4 style={{
                  color: '#2F2F84',
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  marginBottom: '12px',
                  lineHeight: '1.3'
                }}>
                  Rencontrez Ben, Votre Assistant Personnel
                </h4>

                <p style={{
                  color: 'var(--text-secondary)',
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  marginBottom: '20px'
                }}>
                  Ben est votre véritable assistant personnel, disponible par téléphone, WhatsApp, SMS ou directement sur ce site. Il gère vos rendez-vous, vous envoie vos rappels de soins post-opératoires et assure votre suivi personnalisé tout au long de votre parcours.
                </p>

                {/* Feature badges - inline */}
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '12px',
                  marginBottom: '24px'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 14px',
                    background: 'white',
                    borderRadius: '20px',
                    border: '1px solid #E8EAF6',
                    fontSize: '0.85rem'
                  }}>
                    <Clock size={16} color="#2F2F84" />
                    <span style={{ color: '#2F2F84', fontWeight: '600' }}>24/7</span>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 14px',
                    background: 'white',
                    borderRadius: '20px',
                    border: '1px solid #E8EAF6',
                    fontSize: '0.85rem'
                  }}>
                    <Phone size={16} color="#8B6F47" />
                    <span style={{ color: '#2F2F84', fontWeight: '600' }}>Appel & WhatsApp</span>
                  </div>

                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '8px 14px',
                    background: 'white',
                    borderRadius: '20px',
                    border: '1px solid #E8EAF6',
                    fontSize: '0.85rem'
                  }}>
                    <Shield size={16} color="#28a745" />
                    <span style={{ color: '#2F2F84', fontWeight: '600' }}>Suivi & RDV</span>
                  </div>
                </div>

                <button
                  className="btn"
                  onClick={() => {
                    if (window.openBenChat) {
                      window.openBenChat('services-section')
                    }
                  }}
                  style={{
                    background: 'linear-gradient(135deg, #2F2F84 0%, #6466B0 100%)',
                    border: 'none',
                    fontSize: '1rem',
                    padding: '14px 28px',
                    borderRadius: '50px',
                    boxShadow: '0 4px 16px rgba(47, 47, 132, 0.25)',
                    transition: 'all 0.3s ease'
                  }}
                >
                  Parler avec Ben
                </button>
              </div>
            </div>
          </div>

          {/* Supporting Hair Services */}
          <div style={{
            background: 'linear-gradient(135deg, #FFFFFF 0%, #E8EAF6 100%)',
            borderRadius: '16px',
            padding: '40px 30px',
            border: '2px solid #E8EAF6'
          }}>
            <h4 style={{
              textAlign: 'center',
              color: '#2F2F84',
              fontSize: '1.5rem',
              fontWeight: '600',
              marginBottom: '30px'
            }}>
              Soins Capillaires Complémentaires
            </h4>
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '20px'
            }}>
              {hairSupportServices.map((service, index) => (
                <div key={index} style={{
                  background: 'white',
                  borderRadius: '12px',
                  padding: '25px 20px',
                  textAlign: 'center',
                  border: '1px solid #E8EAF6',
                  transition: 'all 0.3s ease'
                }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-2px)'
                    e.currentTarget.style.boxShadow = '0 4px 16px rgba(47, 47, 132, 0.1)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = 'none'
                  }}>
                  <h5 style={{ color: '#2F2F84', fontWeight: '600', marginBottom: '8px' }}>
                    {service.name}
                  </h5>
                  <div style={{ color: '#8B6F47', fontWeight: '600', marginBottom: '10px' }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}><span style={{ color: "#555", fontSize: "0.85rem" }}>à partir de</span><span style={{ color: "inherit" }}>{service.price.replace("à partir de ", "")}</span></div>
                  </div>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.4' }}>
                    {service.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* SECONDARY SECTION: Other Services */}
        <div>
          <h3 style={{
            textAlign: 'center',
            color: '#2F2F84',
            fontSize: '2rem',
            fontWeight: '600',
            marginBottom: '20px'
          }} className="reveal-hidden">
            Autres Services Médicaux
          </h3>
          <p style={{
            textAlign: 'center',
            color: 'var(--text-secondary)',
            marginBottom: '40px',
            fontSize: '1.1rem',
            maxWidth: '600px',
            margin: '0 auto 40px auto'
          }}>
            Services complémentaires de chirurgie et médecine esthétique
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '25px',
            marginBottom: '60px'
          }} className="secondary-services-grid">
            {secondaryServices.map((service, index) => {
              if (service.premium) {
                // DÉTATOUAGE LASER - Premium card with bottom image strip
                return (
                  <div key={index} className="service-card-secondary premium-service detatouage-card" style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    border: '3px solid transparent',
                    backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #2F2F84 0%, #6466B0 50%, #8B6F47 100%)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box',
                    boxShadow: '0 8px 32px rgba(184, 155, 114, 0.2), 0 4px 16px rgba(47, 47, 132, 0.15)',
                    gridColumn: 'span 2',
                    position: 'relative',
                    transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
                  }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-5px)'
                      e.currentTarget.style.boxShadow = '0 16px 48px rgba(184, 155, 114, 0.3), 0 8px 24px rgba(47, 47, 132, 0.2)'
                      const img = e.currentTarget.querySelector('.detatouage-img')
                      if (img) img.style.transform = 'scale(1.06)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = '0 8px 32px rgba(184, 155, 114, 0.2), 0 4px 16px rgba(47, 47, 132, 0.15)'
                      const img = e.currentTarget.querySelector('.detatouage-img')
                      if (img) img.style.transform = 'scale(1)'
                    }}>

                    {/* Top: Content */}
                    <div style={{
                      padding: '36px 35px 28px',
                      textAlign: 'center'
                    }}>
                      {/* TENDANCE badge */}
                      <div style={{
                        display: 'inline-flex',
                        background: 'linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%)',
                        color: 'white',
                        padding: '6px 14px',
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        fontWeight: '700',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        boxShadow: '0 2px 8px rgba(255, 107, 107, 0.3)',
                        marginBottom: '16px'
                      }}>
                        TENDANCE
                      </div>

                      <h4 style={{
                        color: '#2F2F84',
                        fontSize: '1.7rem',
                        fontWeight: '700',
                        marginBottom: '10px',
                        lineHeight: '1.2'
                      }}>
                        {service.name}
                      </h4>

                      <div style={{
                        background: 'linear-gradient(135deg, #E8EAF6 0%, #F0F2FF 100%)',
                        color: '#2F2F84',
                        padding: '8px 16px',
                        borderRadius: '12px',
                        fontSize: '0.9rem',
                        fontWeight: '600',
                        marginBottom: '14px',
                        border: '1px solid #D1D5FF',
                        display: 'inline-block'
                      }}>
                        {service.technology}
                      </div>

                      <div style={{
                        color: '#8B6F47',
                        fontWeight: '700',
                        marginBottom: '14px',
                        fontSize: '1.3rem'
                      }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                          <span style={{ color: "#555", fontSize: "0.9rem" }}>à partir de</span>
                          <span style={{ color: "inherit", textDecoration: 'underline', textUnderlineOffset: '3px' }}>{service.price.replace("à partir de ", "")}</span>
                        </div>
                      </div>

                      <p style={{
                        color: 'var(--text-secondary)',
                        lineHeight: '1.5',
                        marginBottom: '18px',
                        fontSize: '0.95rem',
                        maxWidth: '560px',
                        margin: '0 auto 18px'
                      }}>
                        {service.description}
                      </p>

                      {/* Benefits as 2x2 grid */}
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        gap: '8px',
                        marginBottom: '22px',
                        fontSize: '0.85rem',
                        maxWidth: '480px',
                        margin: '0 auto 22px'
                      }}>
                        {service.benefits.map((benefit, i) => (
                          <div key={i} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            padding: '7px 10px',
                            background: 'rgba(184, 155, 114, 0.08)',
                            borderRadius: '8px',
                            border: '1px solid rgba(184, 155, 114, 0.15)'
                          }}>
                            <CheckCircle size={14} color="#8B6F47" style={{ flexShrink: 0 }} />
                            <span style={{ color: 'var(--text-secondary)', fontWeight: '500' }}>{benefit}</span>
                          </div>
                        ))}
                      </div>

                      <button
                        className="btn btn-gold"
                        onClick={openDoctolib}
                        style={{
                          fontSize: '1rem',
                          fontWeight: '600',
                          padding: '12px 28px'
                        }}
                      >
                        Consultation Gratuite
                        <ArrowRight size={18} />
                      </button>
                    </div>

                    {/* Bottom: Landscape image strip with rounded top */}
                    <div style={{
                      position: 'relative',
                      height: '180px',
                      margin: '0 20px 20px',
                      borderRadius: '16px',
                      overflow: 'hidden',
                      boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.1)'
                    }}>
                      <img
                        className="detatouage-img"
                        src="/assets/services/detatouage-laser.webp"
                        alt="Détatouage laser PicoWay en action"
                        loading="lazy"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          objectPosition: '55% 55%',
                          transition: 'transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                          filter: 'brightness(0.92) contrast(1.08)'
                        }}
                        onError={(e) => {
                          e.target.src = '/assets/services/detatouage-laser.jpg'
                        }}
                      />
                      {/* Subtle vignette overlay */}
                      <div style={{
                        position: 'absolute',
                        inset: 0,
                        background: 'radial-gradient(ellipse at center, transparent 50%, rgba(47, 47, 132, 0.12) 100%)',
                        pointerEvents: 'none'
                      }}></div>
                    </div>
                  </div>
                )
              }

              // Regular service cards
              return (
                <div key={index} style={{
                  background: 'white',
                  borderRadius: '16px',
                  padding: '30px 25px',
                  textAlign: 'center',
                  border: '2px solid #E8EAF6',
                  boxShadow: '0 2px 12px rgba(47, 47, 132, 0.06)',
                  gridColumn: 'span 1',
                  position: 'relative',
                  transition: 'all 0.3s ease'
                }} className="service-card-secondary"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-3px)'
                    e.currentTarget.style.boxShadow = '0 6px 24px rgba(47, 47, 132, 0.12)'
                    e.currentTarget.style.borderColor = '#6466B0'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)'
                    e.currentTarget.style.boxShadow = '0 2px 12px rgba(47, 47, 132, 0.06)'
                    e.currentTarget.style.borderColor = '#E8EAF6'
                  }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>
                    {service.icon}
                  </div>
                  <h4 style={{
                    color: '#2F2F84',
                    fontSize: '1.3rem',
                    fontWeight: '600',
                    marginBottom: '10px'
                  }}>
                    {service.name}
                  </h4>

                  <div style={{
                    color: '#8B6F47',
                    fontWeight: '700',
                    marginBottom: '15px',
                    fontSize: '1.1rem'
                  }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}><span style={{ color: "#555", fontSize: "0.9rem" }}>à partir de</span><span style={{ color: "inherit" }}>{service.price.replace("à partir de ", "")}</span></div>
                  </div>

                  <p style={{
                    color: 'var(--text-secondary)',
                    lineHeight: '1.5',
                    marginBottom: '20px',
                    fontSize: '0.95rem'
                  }}>
                    {service.description}
                  </p>

                  <button
                    className="btn"
                    onClick={openDoctolib}
                    style={{
                      width: '100%',
                      fontSize: '1rem',
                      fontWeight: '500'
                    }}
                  >
                    En savoir plus
                    <ArrowRight size={16} />
                  </button>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServicesSection